import React from 'react';
import { Card, CardContent, Stack } from '@mui/material';
import { CardTitle } from '../common/CardTitle';
import { tokens } from '../../theme/tokens';

interface Props {
  title: string;
  /** what sits at the right of the title: a subtitle, a button, a menu */
  aside?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * The card every Planning section lives in: the same frame, title size and
 * padding as the home dashboard, so the two pages read as one product. The
 * body is a flex column, so a footer can pin itself to the bottom edge.
 */
export const PlanningCard: React.FC<Props> = ({ title, aside, children }) => (
  <Card variant="outlined" sx={{ borderRadius: `${tokens.radius.card}px`, height: '100%', display: 'flex', flexDirection: 'column' }}>
    <CardContent sx={{ p: { xs: 2.25, md: 2.75 }, flex: 1, display: 'flex', flexDirection: 'column', '&:last-child': { pb: { xs: 2.25, md: 2.75 } } }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1.5} sx={{ mb: 1.5 }}>
        <CardTitle>{title}</CardTitle>
        {aside}
      </Stack>
      {children}
    </CardContent>
  </Card>
);
